import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Pill from '../Pill'
import { Strong as MarkdownStrong } from '../Markdown'
import getClassNameFactory from '@wel-ui/utility-class-names'
import './Step.css'

import Heading from '@wel-ui/components/Heading'
import '@wel-ui/components/Heading/index.css'
import Link from '@wel-ui/components/Link'
import '@wel-ui/components/Link/index.css'
import VerticalSpacing from '@wel-ui/components/VerticalSpacing'
import '@wel-ui/components/VerticalSpacing/index.css'
import Button from '@wel-ui/components/Button'
import '@wel-ui/components/Button/index.css'
import Group from '@wel-ui/components/Group'
import '@wel-ui/components/Group/index.css'

import { PoseGroup } from 'react-pose'
import { CrossFade, SlideUp } from '../../animations'
import {
  AnimatedStep,
  AnimatedPills,
  pillsPreceedingDefault,
} from './StepAnimations'

const getClassName = getClassNameFactory('Step')

class Step extends PureComponent {
  static displayName = 'SolutionFinderStep'

  static propTypes = {
    step: PropTypes.object,
    allSteps: PropTypes.object,
    answers: PropTypes.array,
    onNextStepClick: PropTypes.func,
    onFinalStepClick: PropTypes.func,
  }

  render() {
    const { step, allSteps, onNextStepClick, onFinalStepClick } = this.props
    const {
      question,
      subtitle,
      answers = [],
      nextSteps,
      allSolutionsUrl,
      startPage,
    } = step
    if (startPage) {
      return (
        <React.Fragment>
          <VerticalSpacing>
            <Heading type="l" rank="1">
              Every superhero has unique tools and powers. It’s time to find out what type of <strong>tax superhero</strong> you are.
            </Heading>
          </VerticalSpacing>

          <Group>
            <Group.Item>
              <Button
                color="primary"
                kind="button"
                onClick={e => onNextStepClick(['q1'], 'q1')}>
                Start Quiz
              </Button>
            </Group.Item>
          </Group>
        </React.Fragment>
      )
    }
    return (
      <div className={getClassName()}>
        <PoseGroup animateOnMount>
          <AnimatedStep key={step.question}>
            <VerticalSpacing>
              <Heading type="l" rank="1">
                <PoseGroup animateOnMount>
                  <CrossFade key={step.question}>
                    <MarkdownStrong>{question}</MarkdownStrong>
                  </CrossFade>
                </PoseGroup>
              </Heading>
            </VerticalSpacing>

            {subtitle && (
              <VerticalSpacing>
                <Heading type="s" rank="2">
                  <PoseGroup animateOnMount>
                    <CrossFade key={step.subtitle}>{subtitle}</CrossFade>
                  </PoseGroup>
                </Heading>
              </VerticalSpacing>
            )}

            <VerticalSpacing size="xs">
              <AnimatedPills preceeding={subtitle ? pillsPreceedingDefault : 1}>
                <PoseGroup animateOnMount>
                  {answers.map(answer => {
                    const label = answer.answer
                    const { resultsUrl } = step
                    // const { resultsUrl = '' } = allSteps[nextSteps] || {}
                    if (resultsUrl) {
                      return (
                        <SlideUp
                          style={{ display: 'block' }}
                          key={answer.answer}>
                          <Pill
                            nextStep={nextSteps}
                            onClick={e =>
                              onFinalStepClick(e, nextSteps, resultsUrl)
                            }
                            answerLetter={answer.answer_letter}
                            id={step.id}>
                            {label}
                          </Pill>
                        </SlideUp>
                      )
                    }

                    return (
                      <SlideUp
                        style={{ display: 'block' }}
                        key={answer.answer}>
                        <Pill
                          nextStep={nextSteps}
                          onClick={e => onNextStepClick(e, answer)}
                          answerLetter={answer.answer_letter}
                          id={step.id}>
                          {label}
                        </Pill>
                      </SlideUp>
                    )
                  })}
                </PoseGroup>
              </AnimatedPills>
            </VerticalSpacing>

            {/*
            <VerticalSpacing>
              {allSolutionsUrl && (
                <PoseGroup animateOnMount>
                  <CrossFade key={allSolutionsUrl.url}>
                    <Link href={allSolutionsUrl.url} type="primary">
                      {allSolutionsUrl.label}
                    </Link>
                  </CrossFade>
                </PoseGroup>
              )}
            </VerticalSpacing>
                */}
          </AnimatedStep>
        </PoseGroup>
      </div>
    )
  }
}

export default Step



// WEBPACK FOOTER //
// ./js/components/SolutionFinder/Step.js